import FormPage from '../FormPage'

export default class UpdatePassword extends FormPage
{
    static path = '/account/password/update';


    static MaxWidth = 800;

	/**
	 * The css class for the page container
	 *
	 * @var {String}
	 */
	static BGClass = 'bordered-panel';

	/**
	 * The title shown on the form
	 */
	static FormTitle = 'passwords.update.title';

	/**
	 * The subtitle shown on the form
	 */
	static FormSubtitle = "passwords.update.subtitle";

	/**
	 * The submit button title for the form
	 */
	static FormSubmit = 'passwords.update.submit_button';

	/**
     * The api endpoint path that the form should send a post request to
     */
	static FormPost = "/api/passwords/update";

	/**
     * The fields mapping for the form
     */
    static FormFields = {
    	current_password: {
			label: 'passwords.update.current_password_label',
            type: 'password',
        },
        password: {
			label: 'passwords.update.password_label',
			type: 'password',
            autoComplete: 'new-password'
        },
        password_confirmation: {
            type: 'password_confirmation',
			label: 'passwords.update.password_confirmation_label'
        }
    };

	/**
     * Handles successful responses returned by TB Request
     *
     * @param {Object} responseData
     * @returns void
     */
	async onSuccess(responseData)
	{
		await TB.alert(
			'success',
			'passwords.update.success.title',
			'passwords.update.success.message'
		);

		this.formRef?.current?.forceReset({});
	}
}